module.exports = __webpack_public_path__ + "static/girl-c2d404639aed15ad9e05aba1dc2a7f27.png";